const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// shared arrow marker ids avoid collisions
const DEFS = (
  <defs>
    <marker id="arr" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
      <polygon points="0 0,7 3.5,0 7" fill="#e6a817" />
    </marker>
    <marker id="arrR" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
      <polygon points="0 0,7 3.5,0 7" fill="#c0392b" />
    </marker>
    <marker id="arrB" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
      <polygon points="0 0,7 3.5,0 7" fill="#2E75B6" />
    </marker>
    <marker id="arrG" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
      <polygon points="0 0,7 3.5,0 7" fill="#27ae60" />
    </marker>
    <marker id="arrK" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
      <polygon points="0 0,7 3.5,0 7" fill="#333" />
    </marker>
  </defs>
);

// ── Diagram 1: Reflection at a Plane Mirror ───────────────────────
function DiagramPlaneReflection() {
  const W = 860, H = 300;
  // mirror vertical at x=430, y 40-260
  // incident ray from (130,60) to (430,180)
  // normal horizontal at (430,180)
  // reflected ray from (430,180) to (730,60)
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Reflection at a Plane Mirror — Laws of Reflection</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        {DEFS}
        {/* Mirror */}
        <rect x={422} y={35} width={16} height={230} rx={3} fill="#aaa" />
        {[40,60,80,100,120,140,160,180,200,220,240].map((y,i) => (
          <line key={i} x1={438} y1={y} x2={452} y2={y+14} stroke="#888" strokeWidth="1" />
        ))}
        <text x={460} y={145} fontSize="11" fill="#555">Mirror</text>

        {/* Normal dashed line */}
        <line x1={290} y1={180} x2={570} y2={180} stroke="#999" strokeWidth="1.2" strokeDasharray="6,4" />
        <text x={574} y={184} fontSize="10" fill="#555">Normal</text>

        {/* Incident ray */}
        <line x1={130} y1={55} x2={424} y2={178} stroke="#e6a817" strokeWidth="2.2" markerEnd="url(#arr)" />
        <text x={220} y={98} fontSize="11" fill="#e6a817" fontWeight="700">Incident ray</text>

        {/* Reflected ray */}
        <line x1={424} y1={178} x2={720} y2={55} stroke="#c0392b" strokeWidth="2.2" markerEnd="url(#arrR)" />
        <text x={580} y={98} fontSize="11" fill="#c0392b" fontWeight="700">Reflected ray</text>

        {/* Angle of incidence arc */}
        <path d="M 390,180 A 36,36 0 0,0 406,148" fill="none" stroke="#e6a817" strokeWidth="1.5" />
        <text x={340} y={162} fontSize="11" fill="#e6a817" fontWeight="700">θᵢ</text>

        {/* Angle of reflection arc */}
        <path d="M 442,148 A 36,36 0 0,0 458,180" fill="none" stroke="#c0392b" strokeWidth="1.5" />
        <text x={458} y={162} fontSize="11" fill="#c0392b" fontWeight="700">θᵣ</text>

        {/* Virtual image rays */}
        <line x1={424} y1={178} x2={718} y2={178} stroke="#aaa" strokeWidth="1" strokeDasharray="4,3" />
        <line x1={424} y1={178} x2={718} y2={301} stroke="#aaa" strokeWidth="1" strokeDasharray="4,3" />

        {/* Laws box */}
        <rect x={30} y={195} width={260} height={90} rx={5} fill="#fff" stroke="#c0392b" strokeWidth="1.2" />
        <text x={160} y={216} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7B0D0D">Laws of Reflection</text>
        <text x={42} y={234} fontSize="10" fill="#333">1.  θᵢ = θᵣ  (angles measured from normal)</text>
        <text x={42} y={250} fontSize="10" fill="#333">2.  Incident ray, normal and reflected ray</text>
        <text x={42} y={264} fontSize="10" fill="#333">    are all in the same plane.</text>
        <text x={42} y={278} fontSize="10" fill="#333">3.  Applies to all wave types.</text>
      </svg>
      <div style={S.dCaption}>
        The angle of incidence always equals the angle of reflection, both measured from the normal to the surface at the point of incidence. This law holds for any smooth reflective surface regardless of curvature.
      </div>
    </div>
  );
}

// ── Diagram 2: Refraction and Snell's Law ─────────────────────────
function DiagramRefraction() {
  const W = 860, H = 320;
  // boundary at y=160, medium 1 above, medium 2 below
  // incident from (160,40) to (430,160); refracted bends toward normal => (630,280)
  // normal vertical at x=430
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Refraction and Snell's Law — Light Crossing a Boundary</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        {DEFS}
        {/* Media backgrounds */}
        <rect x={0} y={0} width={860} height={160} rx={0} fill="#eaf3ff" opacity="0.5" />
        <rect x={0} y={160} width={860} height={160} rx={0} fill="#fff5f5" opacity="0.5" />

        {/* Boundary */}
        <line x1={0} y1={160} x2={860} y2={160} stroke="#888" strokeWidth="2" strokeDasharray="8,4" />

        {/* Medium labels */}
        <text x={50} y={40} fontSize="12" fontWeight="700" fill="#2E75B6">Medium 1  (n₁, less dense optically)</text>
        <text x={50} y={200} fontSize="12" fontWeight="700" fill="#c0392b">Medium 2  (n₂ &gt; n₁, more dense optically)</text>

        {/* Normal */}
        <line x1={430} y1={20} x2={430} y2={305} stroke="#aaa" strokeWidth="1.2" strokeDasharray="6,4" />
        <text x={436} y={18} fontSize="10" fill="#555">Normal</text>

        {/* Incident ray */}
        <line x1={160} y1={40} x2={430} y2={158} stroke="#e6a817" strokeWidth="2.5" markerEnd="url(#arr)" />
        <text x={240} y={75} fontSize="11" fill="#e6a817" fontWeight="700">Incident ray</text>

        {/* Refracted ray — bends toward normal (steeper) */}
        <line x1={430} y1={162} x2={570} y2={305} stroke="#c0392b" strokeWidth="2.5" markerEnd="url(#arrR)" />
        <text x={528} y={270} fontSize="11" fill="#c0392b" fontWeight="700">Refracted ray</text>

        {/* Reflected ray (weak) */}
        <line x1={430} y1={158} x2={700} y2={40} stroke="#e6a817" strokeWidth="1.2" strokeDasharray="5,3" opacity="0.5" markerEnd="url(#arr)" />
        <text x={600} y={75} fontSize="10" fill="#888" fontStyle="italic">Partial reflection</text>

        {/* θ₁ arc */}
        <path d="M 430,100 A 58,58 0 0,0 390,140" fill="none" stroke="#e6a817" strokeWidth="1.5" />
        <text x={365} y={125} fontSize="12" fill="#e6a817" fontWeight="700">θ₁</text>

        {/* θ₂ arc */}
        <path d="M 452,195 A 58,58 0 0,0 430,220" fill="none" stroke="#c0392b" strokeWidth="1.5" />
        <text x={455} y={218} fontSize="12" fill="#c0392b" fontWeight="700">θ₂</text>

        {/* Snell's Law box */}
        <rect x={580} y={80} width={265} height={115} rx={5} fill="#fff" stroke="#c0392b" strokeWidth="1.2" />
        <text x={712} y={100} textAnchor="middle" fontSize="12" fontWeight="700" fill="#7B0D0D">Snell's Law</text>
        <text x={712} y={120} textAnchor="middle" fontSize="13" fontFamily="'Courier New',monospace" fill="#1a1a2e">n₁ sinθ₁ = n₂ sinθ₂</text>
        <text x={712} y={142} textAnchor="middle" fontSize="10" fill="#555">n₁, n₂ = refractive indices</text>
        <text x={712} y={158} textAnchor="middle" fontSize="10" fill="#555">θ₁ = angle of incidence</text>
        <text x={712} y={174} textAnchor="middle" fontSize="10" fill="#555">θ₂ = angle of refraction</text>

        {/* Speed annotation */}
        <text x={50} y={100} fontSize="10" fill="#2E75B6">Speed v₁ = c/n₁</text>
        <text x={50} y={240} fontSize="10" fill="#c0392b">Speed v₂ = c/n₂  (slower — bends toward normal)</text>
      </svg>
      <div style={S.dCaption}>
        When light enters a denser medium (higher n) it slows down and bends toward the normal. The wavelength changes but the frequency remains constant. The refractive index n = c/v measures how much slower light travels in that medium.
      </div>
    </div>
  );
}

// ── Diagram 3: Total Internal Reflection ─────────────────────────
function DiagramTIR() {
  const W = 860, H = 300;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Total Internal Reflection — Critical Angle and Optical Fibres</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        {DEFS}
        {/* Dense medium below boundary y=140 */}
        <rect x={0} y={140} width={860} height={155} fill="#fff5e6" opacity="0.6" />
        <line x1={0} y1={140} x2={860} y2={140} stroke="#888" strokeWidth="2" />
        <text x={20} y={130} fontSize="11" fill="#888">Less dense  (n₁ &lt; n₂)</text>
        <text x={20} y={180} fontSize="11" fill="#e67e22" fontWeight="700">Denser medium  (n₂)</text>

        {/* ── Case 1: below critical ── */}
        <text x={120} y={22} textAnchor="middle" fontSize="11" fontWeight="700" fill="#2E75B6">θ &lt; θc</text>
        <line x1={120} y1={22} x2={120} y2={135} stroke="#aaa" strokeWidth="1" strokeDasharray="4,3" />
        {/* ray from dense going up at 30 deg */}
        <line x1={120} y1={260} x2={120} y2={142} stroke="#e6a817" strokeWidth="2" markerEnd="url(#arr)" />
        {/* refracted out - bends away */}
        <line x1={120} y1={140} x2={50} y2={22} stroke="#e6a817" strokeWidth="2" markerEnd="url(#arr)" />
        {/* weak reflection */}
        <line x1={120} y1={140} x2={190} y2={22} stroke="#e6a817" strokeWidth="1.2" strokeDasharray="4,3" opacity="0.4" markerEnd="url(#arr)" />
        <text x={120} y={290} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Refraction + partial reflection</text>

        {/* ── Case 2: at critical ── */}
        <text x={380} y={22} textAnchor="middle" fontSize="11" fontWeight="700" fill="#27ae60">θ = θc</text>
        <line x1={380} y1={22} x2={380} y2={135} stroke="#aaa" strokeWidth="1" strokeDasharray="4,3" />
        <line x1={380} y1={260} x2={380} y2={142} stroke="#e6a817" strokeWidth="2" markerEnd="url(#arr)" />
        {/* refracted ray grazes surface */}
        <line x1={380} y1={140} x2={700} y2={138} stroke="#e6a817" strokeWidth="2" markerEnd="url(#arr)" />
        <text x={540} y={128} fontSize="10" fill="#27ae60" fontWeight="700">Grazes surface (90°)</text>
        {/* critical angle arc */}
        <path d="M 380,200 A 60,60 0 0,0 344,155" fill="none" stroke="#27ae60" strokeWidth="1.5" />
        <text x={322} y={188} fontSize="11" fill="#27ae60" fontWeight="700">θc</text>
        <text x={380} y={290} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Refracted ray at 90°</text>

        {/* ── Case 3: above critical ── */}
        <text x={630} y={22} textAnchor="middle" fontSize="11" fontWeight="700" fill="#c0392b">θ &gt; θc  (TIR)</text>
        <line x1={630} y1={22} x2={630} y2={135} stroke="#aaa" strokeWidth="1" strokeDasharray="4,3" />
        <line x1={630} y1={260} x2={630} y2={142} stroke="#e6a817" strokeWidth="2" markerEnd="url(#arr)" />
        {/* fully reflected */}
        <line x1={630} y1={140} x2={790} y2={260} stroke="#c0392b" strokeWidth="2.5" markerEnd="url(#arrR)" />
        {/* TIR angle */}
        <path d="M 630,200 A 60,60 0 0,0 590,155" fill="none" stroke="#c0392b" strokeWidth="1.5" />
        <text x={565} y={190} fontSize="11" fill="#c0392b" fontWeight="700">θ</text>
        <text x={630} y={290} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Total internal reflection</text>

        {/* Critical angle formula */}
        <rect x={260} y={192} width={220} height={46} rx={4} fill="#fff" stroke="#27ae60" strokeWidth="1.2" />
        <text x={370} y={212} textAnchor="middle" fontSize="11" fontWeight="700" fill="#1a1a2e">sin θc = n₁ / n₂</text>
        <text x={370} y={230} textAnchor="middle" fontSize="10" fill="#555">requires n₂ &gt; n₁</text>
      </svg>
      <div style={S.dCaption}>
        TIR occurs only when light travels from a denser to a less dense medium and the angle exceeds the critical angle. This principle traps light in optical fibres, explains the sparkle of diamonds (θc ≈ 24°), and is used in prism binoculars.
      </div>
    </div>
  );
}

// ── Diagram 4: Converging Lens — Ray Diagram ──────────────────────
function DiagramConvergingLens() {
  const W = 860, H = 360;
  // Lens at x=430; f=130 => F at x=300 and x=560
  // Object at x=200, height 90 (tip at y=90, base at y=180 = optical axis)
  // Image: using 1/v - 1/u = 1/f => u=-230, f=130 => 1/v = 1/130+1/230? 
  // Use u=230 (object dist), f=130: 1/v=1/f-1/u... let's use thin lens: 1/v=1/f+1/(-u) -> real image
  // u=230, f=130 => 1/v = 1/130 - 1/230 = (230-130)/(130*230)=100/29900 => v=299 => x=430+299=729, capped
  // magnification m = -v/u = -299/230 ≈ -1.3 => image height ≈ -117 (inverted), tip at y=180+117=297
  const axis = 180;
  const lensX = 430;
  const objX = 200, objTipY = 90;   // object tip
  const imgX = 729, imgTipY = 297;  // image tip (inverted, below axis)
  const F1x = 300, F2x = 560;       // focal points

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Converging (Convex) Lens — Ray Diagram for Real Inverted Image</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        {DEFS}
        {/* Optical axis */}
        <line x1={20} y1={axis} x2={840} y2={axis} stroke="#bbb" strokeWidth="1.2" strokeDasharray="6,4" />

        {/* Lens shape */}
        <path d={`M ${lensX} 50 C ${lensX+45} 100 ${lensX+45} 260 ${lensX} 310`}
          fill="none" stroke="#2E75B6" strokeWidth="2.5" />
        <path d={`M ${lensX} 50 C ${lensX-45} 100 ${lensX-45} 260 ${lensX} 310`}
          fill="none" stroke="#2E75B6" strokeWidth="2.5" />
        <text x={lensX} y={330} textAnchor="middle" fontSize="10" fill="#2E75B6">Converging lens</text>

        {/* Focal points */}
        <circle cx={F1x} cy={axis} r={5} fill="#c0392b" />
        <text x={F1x} y={axis-10} textAnchor="middle" fontSize="11" fill="#c0392b" fontWeight="700">F</text>
        <circle cx={F2x} cy={axis} r={5} fill="#c0392b" />
        <text x={F2x} y={axis-10} textAnchor="middle" fontSize="11" fill="#c0392b" fontWeight="700">F</text>
        {/* 2F points */}
        <circle cx={F1x-130} cy={axis} r={3} fill="#aaa" />
        <text x={F1x-130} y={axis+16} textAnchor="middle" fontSize="10" fill="#aaa">2F</text>
        <circle cx={F2x+130} cy={axis} r={3} fill="#aaa" />
        <text x={F2x+130} y={axis+16} textAnchor="middle" fontSize="10" fill="#aaa">2F</text>

        {/* Object arrow */}
        <line x1={objX} y1={axis} x2={objX} y2={objTipY} stroke="#27ae60" strokeWidth="2.5" markerEnd="url(#arrG)" />
        <text x={objX-8} y={axis-50} textAnchor="end" fontSize="11" fill="#27ae60" fontWeight="700">Object</text>

        {/* Image arrow */}
        <line x1={imgX} y1={axis} x2={imgX} y2={imgTipY} stroke="#9b59b6" strokeWidth="2.5" markerEnd="url(#arrR)" />
        <text x={imgX+8} y={imgTipY+16} fontSize="11" fill="#9b59b6" fontWeight="700">Image (real, inverted)</text>

        {/* Ray 1: parallel to axis → through F2 */}
        <line x1={objX} y1={objTipY} x2={lensX} y2={objTipY} stroke="#e6a817" strokeWidth="1.8" markerEnd="url(#arr)" />
        <line x1={lensX} y1={objTipY} x2={imgX} y2={imgTipY} stroke="#e6a817" strokeWidth="1.8" markerEnd="url(#arr)" />
        <text x={300} y={objTipY-8} fontSize="9" fill="#e6a817">① parallel → through F</text>

        {/* Ray 2: through centre → undeviated */}
        <line x1={objX} y1={objTipY} x2={imgX} y2={imgTipY} stroke="#c0392b" strokeWidth="1.8" strokeDasharray="7,3" markerEnd="url(#arrR)" />
        <text x={380} y={130} fontSize="9" fill="#c0392b">② through centre (undeviated)</text>

        {/* Ray 3: through F1 → parallel after lens */}
        <line x1={objX} y1={objTipY} x2={lensX} y2={axis + (axis-objTipY)*(lensX-objX)/(F1x-objX)} stroke="#2E75B6" strokeWidth="1.8" markerEnd="url(#arrB)" />
        <line x1={lensX} y1={axis + (axis-objTipY)*(lensX-objX)/(F1x-objX)} x2={imgX} y2={imgTipY} stroke="#2E75B6" strokeWidth="1.8" markerEnd="url(#arrB)" />
        <text x={300} y={210} fontSize="9" fill="#2E75B6">③ through F → parallel after lens</text>

        {/* Distance labels */}
        <line x1={objX} y1={340} x2={lensX} y2={340} stroke="#555" strokeWidth="1" />
        <text x={(objX+lensX)/2} y={355} textAnchor="middle" fontSize="10" fill="#555">u (object distance)</text>
        <line x1={lensX} y1={340} x2={imgX} y2={340} stroke="#555" strokeWidth="1" />
        <text x={(lensX+imgX)/2} y={355} textAnchor="middle" fontSize="10" fill="#555">v (image distance)</text>
      </svg>
      <div style={S.dCaption}>
        Three principal rays locate the image: (①) parallel to axis refracts through far focal point; (②) through optical centre passes undeviated; (③) through near focal point emerges parallel. All three converge at the image point.
      </div>
    </div>
  );
}

// ── Diagram 5: Diverging Lens — Virtual Image ────────────────────
function DiagramDivergingLens() {
  const W = 860, H = 320;
  const axis = 160;
  const lensX = 430;
  // object at x=200, tip y=60; diverging f=-120 => F at x=310 (near, virtual) and x=550 (far, virtual)
  // 1/v = 1/f + 1/u ... sign convention real-is-positive: u=+230, f=-120
  // 1/v = -1/120 + 1/230 ... wait, use 1/v = 1/f - 1/u for cartesian
  // 1/v = 1/(-120) - 1/(-230) = -1/120 + 1/230 = (-230+120)/(120*230) = -110/27600 => v=-251
  // image at lensX - 251 = 179 (left of lens), tip: m=v/u=-251/-230 ≈ 1.09... 
  // let's simplify: image at x=250, tip y=100 (upright, smaller)
  const objX = 200, objTipY = 60;
  const imgX = 250, imgTipY = 108; // virtual, upright, smaller
  const Fv1 = 310, Fv2 = 550; // virtual focal points

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Diverging (Concave) Lens — Ray Diagram for Virtual Upright Image</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        {DEFS}
        {/* Optical axis */}
        <line x1={20} y1={axis} x2={840} y2={axis} stroke="#bbb" strokeWidth="1.2" strokeDasharray="6,4" />

        {/* Diverging lens shape */}
        <path d={`M ${lensX-10} 40 C ${lensX+20} 100 ${lensX+20} 220 ${lensX-10} 280`}
          fill="none" stroke="#c0392b" strokeWidth="2.5" />
        <path d={`M ${lensX+10} 40 C ${lensX-20} 100 ${lensX-20} 220 ${lensX+10} 280`}
          fill="none" stroke="#c0392b" strokeWidth="2.5" />
        <text x={lensX} y={295} textAnchor="middle" fontSize="10" fill="#c0392b">Diverging lens</text>

        {/* Virtual focal points */}
        <circle cx={Fv1} cy={axis} r={5} fill="#c0392b" opacity="0.5" />
        <text x={Fv1} y={axis-10} textAnchor="middle" fontSize="10" fill="#c0392b" fontStyle="italic">F (virtual)</text>
        <circle cx={Fv2} cy={axis} r={5} fill="#c0392b" opacity="0.5" />
        <text x={Fv2} y={axis-10} textAnchor="middle" fontSize="10" fill="#c0392b" fontStyle="italic">F (virtual)</text>

        {/* Object */}
        <line x1={objX} y1={axis} x2={objX} y2={objTipY} stroke="#27ae60" strokeWidth="2.5" markerEnd="url(#arrG)" />
        <text x={objX-8} y={75} textAnchor="end" fontSize="11" fill="#27ae60" fontWeight="700">Object</text>

        {/* Virtual image (dashed box) */}
        <line x1={imgX} y1={axis} x2={imgX} y2={imgTipY} stroke="#9b59b6" strokeWidth="2" strokeDasharray="5,3" />
        <text x={imgX+8} y={imgTipY-6} fontSize="11" fill="#9b59b6" fontWeight="700">Virtual image</text>
        <text x={imgX+8} y={imgTipY+8} fontSize="10" fill="#9b59b6">(upright, smaller)</text>

        {/* Ray 1: parallel → diverges as if from F1 */}
        <line x1={objX} y1={objTipY} x2={lensX} y2={objTipY} stroke="#e6a817" strokeWidth="1.8" markerEnd="url(#arr)" />
        {/* after lens diverges toward Fv1 extension */}
        <line x1={lensX} y1={objTipY} x2={700} y2={objTipY + (objTipY - axis)*1.6} stroke="#e6a817" strokeWidth="1.8" markerEnd="url(#arr)" />
        {/* back-traced dashed to virtual image */}
        <line x1={lensX} y1={objTipY} x2={imgX} y2={imgTipY} stroke="#e6a817" strokeWidth="1.2" strokeDasharray="5,3" opacity="0.6" />
        <text x={560} y={objTipY-8} fontSize="9" fill="#e6a817">① parallel → diverges from F</text>

        {/* Ray 2: through centre undeviated */}
        <line x1={objX} y1={objTipY} x2={700} y2={axis + (axis-objTipY)*1.05} stroke="#c0392b" strokeWidth="1.8" strokeDasharray="7,3" markerEnd="url(#arrR)" />
        <text x={600} y={axis+40} fontSize="9" fill="#c0392b">② through centre (undeviated)</text>

        {/* Thin lens formula box */}
        <rect x={580} y={30} width={265} height={80} rx={5} fill="#fff" stroke="#c0392b" strokeWidth="1.2" />
        <text x={712} y={52} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7B0D0D">Thin Lens Formula</text>
        <text x={712} y={72} textAnchor="middle" fontSize="13" fontFamily="'Courier New',monospace" fill="#1a1a2e">1/f = 1/v − 1/u</text>
        <text x={712} y={90} textAnchor="middle" fontSize="10" fill="#555">or  1/v + 1/u = 1/f  (real-positive)</text>
        <text x={712} y={104} textAnchor="middle" fontSize="10" fill="#555">Diverging: f is negative</text>
      </svg>
      <div style={S.dCaption}>
        A diverging lens always produces a virtual, upright, diminished image on the same side as the object. The back-traced diverging rays appear to come from the virtual focal point. Used in spectacles for short-sightedness (myopia).
      </div>
    </div>
  );
}

// ── Diagram 6: Curved Mirrors ─────────────────────────────────────
function DiagramCurvedMirrors() {
  const W = 860, H = 310;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Curved Mirrors — Concave and Convex</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        {DEFS}

        {/* ── Concave mirror (left) ── */}
        <rect x={15} y={10} width={400} height={290} rx={8} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.5" />
        <text x={215} y={30} textAnchor="middle" fontSize="12" fontWeight="700" fill="#2E75B6">Concave Mirror (converging)</text>

        {/* Mirror arc */}
        <path d="M 360,60 Q 420,155 360,250" fill="none" stroke="#2E75B6" strokeWidth="3" />
        {/* hatching */}
        {[70,90,110,130,150,170,190,210,230].map((y,i) => (
          <line key={i} x1={360 + (155-y)*(155-y)/1800} y1={y} x2={360 + (155-y)*(155-y)/1800 + 12} y2={y+12} stroke="#2E75B6" strokeWidth="1" opacity="0.5" />
        ))}

        {/* Axis */}
        <line x1={30} y1={155} x2={420} y2={155} stroke="#bbb" strokeWidth="1.2" strokeDasharray="5,3" />

        {/* Focal point and centre */}
        <circle cx={240} cy={155} r={5} fill="#c0392b" />
        <text x={240} y={172} textAnchor="middle" fontSize="10" fill="#c0392b" fontWeight="700">F</text>
        <circle cx={335} cy={155} r={4} fill="#aaa" />
        <text x={335} y={172} textAnchor="middle" fontSize="10" fill="#aaa">C</text>

        {/* Object */}
        <line x1={130} y1={155} x2={130} y2={95} stroke="#27ae60" strokeWidth="2.5" markerEnd="url(#arrG)" />
        <text x={130} y={88} textAnchor="middle" fontSize="10" fill="#27ae60">Obj</text>

        {/* Ray 1: parallel → reflects through F */}
        <line x1={130} y1={95} x2={358} y2={95} stroke="#e6a817" strokeWidth="1.8" markerEnd="url(#arr)" />
        <line x1={358} y1={95} x2={240} y2={155} stroke="#e6a817" strokeWidth="1.8" markerEnd="url(#arr)" />
        <line x1={240} y1={155} x2={50} y2={260} stroke="#e6a817" strokeWidth="1.8" opacity="0.3" />

        {/* Image */}
        <line x1={310} y1={155} x2={310} y2={215} stroke="#9b59b6" strokeWidth="2.5" markerEnd="url(#arrR)" />
        <text x={310} y={232} textAnchor="middle" fontSize="10" fill="#9b59b6">Image</text>
        <text x={310} y={244} textAnchor="middle" fontSize="9" fill="#9b59b6">(real, inverted)</text>

        {/* Mirror formula */}
        <rect x={25} y={245} width={170} height={44} rx={4} fill="#fff" stroke="#2E75B6" strokeWidth="1" />
        <text x={110} y={263} textAnchor="middle" fontSize="10" fontWeight="700" fill="#1a1a2e">Mirror formula:</text>
        <text x={110} y={280} textAnchor="middle" fontSize="11" fontFamily="'Courier New',monospace" fill="#1a1a2e">1/f = 1/v + 1/u</text>

        {/* ── Convex mirror (right) ── */}
        <rect x={440} y={10} width={405} height={290} rx={8} fill="#fff5f5" stroke="#c0392b" strokeWidth="1.5" />
        <text x={642} y={30} textAnchor="middle" fontSize="12" fontWeight="700" fill="#c0392b">Convex Mirror (diverging)</text>

        {/* Mirror arc — curves away */}
        <path d="M 510,60 Q 450,155 510,250" fill="none" stroke="#c0392b" strokeWidth="3" />
        {[70,90,110,130,150,170,190,210,230].map((y,i) => (
          <line key={i} x1={510 - (155-y)*(155-y)/1800} y1={y} x2={510 - (155-y)*(155-y)/1800 - 12} y2={y+12} stroke="#c0392b" strokeWidth="1" opacity="0.5" />
        ))}

        {/* Axis */}
        <line x1={450} y1={155} x2={840} y2={155} stroke="#bbb" strokeWidth="1.2" strokeDasharray="5,3" />

        {/* Virtual focal point */}
        <circle cx={610} cy={155} r={5} fill="#c0392b" opacity="0.5" />
        <text x={610} y={172} textAnchor="middle" fontSize="10" fill="#c0392b">F (virtual)</text>

        {/* Object */}
        <line x1={750} y1={155} x2={750} y2={90} stroke="#27ae60" strokeWidth="2.5" markerEnd="url(#arrG)" />
        <text x={750} y={83} textAnchor="middle" fontSize="10" fill="#27ae60">Obj</text>

        {/* Incident ray 1: parallel → diverges as if from virtual F */}
        <line x1={750} y1={90} x2={513} y2={90} stroke="#e6a817" strokeWidth="1.8" markerEnd="url(#arr)" />
        <line x1={513} y1={90} x2={800} y2={130} stroke="#e6a817" strokeWidth="1.8" markerEnd="url(#arr)" />
        <line x1={513} y1={90} x2={610} y2={155} stroke="#e6a817" strokeWidth="1.2" strokeDasharray="5,3" opacity="0.5" />

        {/* Virtual image */}
        <line x1={570} y1={155} x2={570} y2={122} stroke="#9b59b6" strokeWidth="2" strokeDasharray="5,3" />
        <text x={570} y={113} textAnchor="middle" fontSize="10" fill="#9b59b6">Virtual image</text>
        <text x={570} y={124} textAnchor="middle" fontSize="9" fill="#9b59b6">(upright, smaller)</text>

        <text x={642} y={265} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Always virtual, upright, diminished — used in rear-view mirrors</text>
      </svg>
      <div style={S.dCaption}>
        A concave mirror converges parallel rays to a real focal point in front of the mirror. A convex mirror diverges rays; its focal point is virtual (behind the mirror). The mirror equation 1/f = 1/v + 1/u applies to both (with sign convention).
      </div>
    </div>
  );
}

// ── Diagram 7: Dispersion through a Prism ────────────────────────
function DiagramPrism() {
  const W = 860, H = 300;
  const colors = [
    { c:'#c0392b', label:'Red',    dy:0  },
    { c:'#e67e22', label:'Orange', dy:8  },
    { c:'#f1c40f', label:'Yellow', dy:14 },
    { c:'#27ae60', label:'Green',  dy:20 },
    { c:'#2E75B6', label:'Blue',   dy:26 },
    { c:'#9b59b6', label:'Violet', dy:34 },
  ];
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Dispersion — White Light through a Prism</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        {DEFS}
        {/* Prism */}
        <polygon points="330,40 550,40 440,260" fill="#d6eaf8" stroke="#2E75B6" strokeWidth="2" opacity="0.7" />
        <text x={440} y={180} textAnchor="middle" fontSize="11" fill="#2E75B6" fontWeight="700">Prism</text>
        <text x={440} y={196} textAnchor="middle" fontSize="10" fill="#2E75B6">glass</text>

        {/* White incident ray */}
        <line x1={120} y1={130} x2={362} y2={130} stroke="#888" strokeWidth="4" markerEnd="url(#arrK)" />
        <text x={120} y={118} fontSize="11" fill="#555" fontWeight="700">White light</text>

        {/* Dispersed rays emerging */}
        {colors.map((cl, i) => (
          <line key={i}
            x1={490} y1={138 + i*4}
            x2={760} y2={80 + cl.dy + i*22}
            stroke={cl.c} strokeWidth="2.2"
            markerEnd="url(#arrK)"
            opacity="0.9"
          />
        ))}
        {colors.map((cl, i) => (
          <text key={i} x={766} y={84 + cl.dy + i*22} fontSize="10" fill={cl.c} fontWeight="700">{cl.label}</text>
        ))}

        {/* n annotation */}
        <rect x={20} y={180} width={280} height={110} rx={5} fill="#fff" stroke="#2E75B6" strokeWidth="1.2" />
        <text x={160} y={200} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7B0D0D">Why dispersion occurs</text>
        <text x={30} y={218} fontSize="10" fill="#333">• n varies with wavelength (λ)</text>
        <text x={30} y={234} fontSize="10" fill="#333">• Shorter λ (violet) → higher n → bends more</text>
        <text x={30} y={250} fontSize="10" fill="#333">• Longer λ (red) → lower n → bends less</text>
        <text x={30} y={266} fontSize="10" fill="#333">• Cauchy: n ≈ A + B/λ²</text>
        <text x={30} y={282} fontSize="10" fill="#333">• Abbe number V = (n_D−1)/(n_F−n_C)</text>
      </svg>
      <div style={S.dCaption}>
        Dispersion occurs because the refractive index of glass depends on wavelength (normal dispersion: n increases as λ decreases). Violet light is refracted more than red, spreading white light into its spectral components.
      </div>
    </div>
  );
}

// ── Diagram 8: Image Formation Summary Table (Convex Lens) ────────
function DiagramLensImages() {
  const W = 860, H = 340;
  const cases = [
    { objPos:'Beyond 2F',    imgPos:'Between F and 2F', nature:'Real, inverted, diminished',  use:'Camera, eye'          },
    { objPos:'At 2F',        imgPos:'At 2F',             nature:'Real, inverted, same size',   use:'Photocopier (1:1)'    },
    { objPos:'Between F–2F', imgPos:'Beyond 2F',         nature:'Real, inverted, magnified',   use:'Projector, slide'     },
    { objPos:'At F',         imgPos:'At infinity',       nature:'No image formed (parallel)',  use:'Spotlight, collimator'},
    { objPos:'Within F',     imgPos:'Same side as obj',  nature:'Virtual, upright, magnified', use:'Magnifying glass'     },
  ];
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Image Characteristics — Converging Lens (Object Position vs Image Properties)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        {/* Header */}
        {['Object Position','Image Position','Nature of Image','Practical Use'].map((h, i) => (
          <rect key={i} x={10 + i*213} y={10} width={210} height={30} rx={0} fill="#c0392b" />
        ))}
        {['Object Position','Image Position','Nature of Image','Practical Use'].map((h, i) => (
          <text key={i} x={115 + i*213} y={30} textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff">{h}</text>
        ))}
        {cases.map((c, row) => {
          const y = 40 + row * 56;
          const bg = row % 2 === 0 ? '#fff5f5' : '#fff';
          return (
            <g key={row}>
              {[c.objPos, c.imgPos, c.nature, c.use].map((val, col) => (
                <g key={col}>
                  <rect x={10 + col*213} y={y} width={210} height={54} fill={bg} stroke="#f0cece" strokeWidth="1" />
                  <text x={115 + col*213} y={y + 28} textAnchor="middle" fontSize="10" fill="#1a1a2e">{val}</text>
                </g>
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>
        The nature of the image produced by a converging lens depends entirely on where the object is placed relative to the focal length. Only when the object is inside the focal length is the image virtual and upright.
      </div>
    </div>
  );
}

// ── Diagram 9: The Human Eye and Defects ─────────────────────────
function DiagramEye() {
  const W = 860, H = 300;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>The Human Eye — Optical Structure and Defects of Vision</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        {DEFS}

        {/* ── Normal eye ── */}
        <rect x={15} y={15} width={260} height={270} rx={8} fill="#f0fff4" stroke="#27ae60" strokeWidth="1.5" />
        <text x={145} y={36} textAnchor="middle" fontSize="11" fontWeight="700" fill="#27ae60">Normal Eye</text>
        {/* Eye outline */}
        <ellipse cx={145} cy={155} rx={90} ry={70} fill="#fffde7" stroke="#888" strokeWidth="1.5" />
        {/* Cornea */}
        <path d="M 75,155 Q 55,130 75,105" fill="none" stroke="#2E75B6" strokeWidth="3" />
        {/* Lens */}
        <path d="M 105,140 Q 120,155 105,170" fill="none" stroke="#c0392b" strokeWidth="2.5" />
        <path d="M 115,140 Q 100,155 115,170" fill="none" stroke="#c0392b" strokeWidth="2.5" />
        {/* Retina */}
        <path d="M 225,105 Q 245,155 225,205" fill="none" stroke="#e67e22" strokeWidth="3" />
        {/* Rays converging on retina */}
        <line x1={50} y1={120} x2={220} y2={152} stroke="#e6a817" strokeWidth="1.5" markerEnd="url(#arr)" />
        <line x1={50} y1={190} x2={220} y2={158} stroke="#e6a817" strokeWidth="1.5" markerEnd="url(#arr)" />
        <text x={145} y={268} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Image focused on retina</text>
        {['Cornea','Lens','Retina'].map((l, i) => (
          <text key={i} x={[64, 95, 230][i]} y={[98, 132, 98][i]} fontSize="8" fill="#555">{l}</text>
        ))}

        {/* ── Myopia ── */}
        <rect x={298} y={15} width={260} height={270} rx={8} fill="#fff5f5" stroke="#c0392b" strokeWidth="1.5" />
        <text x={428} y={36} textAnchor="middle" fontSize="11" fontWeight="700" fill="#c0392b">Myopia (Short-sighted)</text>
        <ellipse cx={428} cy={155} rx={95} ry={70} fill="#fffde7" stroke="#888" strokeWidth="1.5" />
        <path d="M 333,155 Q 313,128 333,101" fill="none" stroke="#2E75B6" strokeWidth="3" />
        <path d="M 363,138 Q 380,155 363,172" fill="none" stroke="#c0392b" strokeWidth="2.5" />
        <path d="M 375,138 Q 358,155 375,172" fill="none" stroke="#c0392b" strokeWidth="2.5" />
        <path d="M 508,105 Q 528,155 508,205" fill="none" stroke="#e67e22" strokeWidth="3" />
        {/* Focus in front of retina */}
        <line x1={310} y1={118} x2={460} y2={152} stroke="#e6a817" strokeWidth="1.5" markerEnd="url(#arr)" />
        <line x1={310} y1={192} x2={460} y2={158} stroke="#e6a817" strokeWidth="1.5" markerEnd="url(#arr)" />
        <circle cx={460} cy={155} r={4} fill="#c0392b" />
        <text x={460} y={145} textAnchor="middle" fontSize="9" fill="#c0392b">focus here</text>
        <text x={428} y={238} textAnchor="middle" fontSize="10" fill="#c0392b">Eye too long / lens too strong</text>
        <text x={428} y={253} textAnchor="middle" fontSize="10" fill="#555">Corrected by: concave (−) lens</text>
        <text x={428} y={268} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Diverges light before entering eye</text>

        {/* ── Hyperopia ── */}
        <rect x={581} y={15} width={264} height={270} rx={8} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.5" />
        <text x={713} y={36} textAnchor="middle" fontSize="11" fontWeight="700" fill="#2E75B6">Hyperopia (Long-sighted)</text>
        <ellipse cx={713} cy={155} rx={85} ry={70} fill="#fffde7" stroke="#888" strokeWidth="1.5" />
        <path d="M 628,155 Q 610,130 628,105" fill="none" stroke="#2E75B6" strokeWidth="3" />
        <path d="M 655,140 Q 670,155 655,170" fill="none" stroke="#c0392b" strokeWidth="2.5" />
        <path d="M 665,140 Q 650,155 665,170" fill="none" stroke="#c0392b" strokeWidth="2.5" />
        <path d="M 790,105 Q 808,155 790,205" fill="none" stroke="#e67e22" strokeWidth="3" />
        {/* Would focus behind retina */}
        <line x1={605} y1={118} x2={788} y2={150} stroke="#e6a817" strokeWidth="1.5" markerEnd="url(#arr)" />
        <line x1={605} y1={192} x2={788} y2={160} stroke="#e6a817" strokeWidth="1.5" markerEnd="url(#arr)" />
        <line x1={788} y1={155} x2={830} y2={155} stroke="#e6a817" strokeWidth="1.2" strokeDasharray="4,3" opacity="0.5" />
        <circle cx={830} cy={155} r={4} fill="#2E75B6" opacity="0.5" />
        <text x={713} y={238} textAnchor="middle" fontSize="10" fill="#2E75B6">Eye too short / lens too weak</text>
        <text x={713} y={253} textAnchor="middle" fontSize="10" fill="#555">Corrected by: convex (+) lens</text>
        <text x={713} y={268} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Converges light before entering eye</text>
      </svg>
      <div style={S.dCaption}>
        The eye acts as a variable-power converging lens system. Accommodation — changing the curvature of the crystalline lens — adjusts focus. Refractive errors occur when the focal point misses the retina and are corrected with external lenses of appropriate power.
      </div>
    </div>
  );
}

export default function GeometricOptics() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Geometric Optics</h1>

      <p style={S.p}>
        Geometric optics — also called <strong>ray optics</strong> — treats light as straight-line rays that travel until they encounter a reflective or refractive surface. This approximation is valid whenever the objects and apertures involved are much larger than the wavelength of light (~500 nm), making it the foundation of lens design, mirror systems, the human eye, cameras, telescopes, microscopes, and fibre-optic communications.
      </p>
      <p style={S.p}>
        The subject rests on two fundamental experimental laws — the <strong>law of reflection</strong> and <strong>Snell's law of refraction</strong> — from which an enormously rich set of consequences follows. By tracing the paths of representative rays through optical systems, we can predict where images form, whether they are real or virtual, upright or inverted, magnified or diminished, and what aberrations degrade their quality.
      </p>
      <p style={S.p}>
        Geometric optics does not account for diffraction or interference, which require wave optics. However, within its domain it provides exact analytical tools and guides the engineering of virtually every optical instrument ever made — from spectacles to the James Webb Space Telescope.
      </p>

      <InfoBox title="What This Page Covers" items={[
        "Laws of reflection — plane mirrors, virtual images, lateral inversion",
        "Refraction and Snell's Law — refractive index, bending of rays",
        "Total internal reflection — critical angle, optical fibres, diamonds",
        "Thin lens formula — converging and diverging lenses, sign convention",
        "Ray diagrams — three principal rays, locating real and virtual images",
        "Lens power and the dioptre — lensmaker's equation",
        "Curved mirrors — concave and convex, mirror formula",
        "Magnification — linear and angular, transverse and longitudinal",
        "Dispersion and the prism — Cauchy equation, Abbe number",
        "The human eye — accommodation, myopia, hyperopia, astigmatism",
        "Optical instruments — magnifying glass, microscope, telescope, camera",
        "Aberrations — spherical, chromatic, coma, astigmatism",
      ]}/>

      <h2 style={S.h2}>The Law of Reflection</h2>
      <p style={S.p}>
        When light strikes a smooth surface it is reflected such that the angle of incidence equals the angle of reflection, both measured from the <strong>normal</strong> (the line perpendicular to the surface at the point of contact). This law holds for every wave type and every surface geometry — the normal simply changes direction on curved surfaces, meaning each small patch obeys the law locally.
      </p>
      <DiagramPlaneReflection/>
      <Table2 rows={[
        ["Law of reflection","θᵢ = θᵣ  (both measured from the normal)\nThe incident ray, normal, and reflected ray are coplanar"],
        ["Plane mirror image","Virtual (behind mirror), upright, same size as object\nImage distance behind mirror = object distance in front"],
        ["Lateral inversion","Left and right are swapped in a plane mirror image\nText appears reversed; not top-bottom inversion"],
        ["Multiple reflections","Two mirrors at angle θ form n = (360°/θ) − 1 images (if 360/θ is integer)\nKaleidoscope: mirrors at 60° → 5 images"],
        ["Specular vs diffuse","Specular: smooth surface → clear reflected image (mirror, still water)\nDiffuse: rough surface → light scattered in many directions (paper, walls)"],
        ["Corner reflector","Three mutually perpendicular mirrors reflect any ray back parallel to incident\nUsed in cat's-eye road studs, lunar ranging experiments, bike reflectors"],
        ["Retroreflection","Incident and reflected rays are anti-parallel (180°)\nAchieved by corner reflectors and microsphere arrays in road markings"],
      ]}/>

      <h2 style={S.h2}>Refraction and Snell's Law</h2>
      <p style={S.p}>
        When light crosses a boundary between two transparent media of different optical density, it changes speed. If it strikes the boundary at an angle, it also changes direction — it is <strong>refracted</strong>. The amount of bending is governed by <strong>Snell's Law</strong>, which follows from requiring wavefronts to remain continuous across the boundary (Fermat's principle of least time gives the same result).
      </p>
      <DiagramRefraction/>
      <Table2 rows={[
        ["Snell's Law","n₁ sinθ₁ = n₂ sinθ₂\nn = refractive index of each medium, θ measured from normal"],
        ["Refractive index","n = c/v  (dimensionless, ≥ 1 for all materials)\nVacuum: n = 1; air: n ≈ 1.0003; water: n ≈ 1.33; glass: n ≈ 1.5; diamond: n ≈ 2.42"],
        ["Relative refractive index","₁n₂ = n₂/n₁ = v₁/v₂ = sinθ₁/sinθ₂\nRatio describing bending at a specific boundary"],
        ["Wavelength change","λ_medium = λ_vacuum / n\nFrequency is unchanged; wavelength and speed both decrease"],
        ["Bending direction","Into denser medium (n₂ > n₁): bends toward normal (θ₂ < θ₁)\nInto less dense medium: bends away from normal (θ₂ > θ₁)"],
        ["Fermat's Principle","Light takes the path of stationary (usually minimum) time\nDerives Snell's Law and the law of reflection as special cases"],
        ["Apparent depth","d_apparent = d_real / n  (normal incidence)\nPool appears shallower; fish appears higher than it is"],
        ["Lateral shift in glass slab","Ray exits parallel to incident but displaced sideways\nShift d = t sinθ₁ (1 − cosθ₁/cosθ₂) / cosθ₂  (t = slab thickness)"],
        ["Mirage","Hot air near ground is less dense → n is lower → rays bend upward\nCreates virtual image of sky appearing as water on road surface"],
      ]}/>

      <h2 style={S.h2}>Total Internal Reflection</h2>
      <p style={S.p}>
        When light in a denser medium strikes the boundary with a less dense medium at an angle greater than the <strong>critical angle</strong>, <em>all</em> the light is reflected back — none escapes. This phenomenon, called <strong>total internal reflection (TIR)</strong>, enables optical fibres to guide light around bends with virtually no loss, and gives diamonds their extraordinary brilliance.
      </p>
      <DiagramTIR/>
      <Table2 rows={[
        ["Critical angle","sinθc = n₁/n₂  (requires n₂ > n₁)\nFor glass–air: θc = arcsin(1/1.5) ≈ 42°; diamond–air: θc ≈ 24°"],
        ["TIR condition","θ ≥ θc AND light travelling from denser to less dense medium\nBoth conditions must hold simultaneously"],
        ["Optical fibre (step-index)","Core (n₂ ≈ 1.50) surrounded by cladding (n₁ ≈ 1.46)\nLight undergoes repeated TIR along core; travels ~200 km without amplifier"],
        ["Numerical aperture","NA = n₀ sinθ_max = √(n₂² − n₁²)\nMaximum angle at which light can enter fibre and still undergo TIR"],
        ["Modal dispersion","Different ray angles travel different path lengths → pulse spreading\nSingle-mode fibre eliminates this by making core narrow (~8 μm)"],
        ["Graded-index fibre","Refractive index decreases gradually from core centre\nRays follow curved paths; all modes arrive at similar times — less dispersion"],
        ["Diamond brilliance","θc ≈ 24° means most internal rays undergo TIR\nFacets angled to direct TIR light toward viewer — maximises sparkle"],
        ["Prism reflector","45° prism: θc for glass ≈ 42°, so 45° > θc → TIR at 90°\nUsed in binoculars, periscopes, rangefinders — more efficient than aluminised mirror"],
        ["Evanescent wave","At TIR boundary, exponentially decaying field extends ~λ into less dense medium\nBasis of attenuated total reflection (ATR) spectroscopy and fibre coupling"],
      ]}/>

      <h2 style={S.h2}>Thin Lenses — Converging</h2>
      <p style={S.p}>
        A <strong>thin lens</strong> is one whose thickness is negligible compared to the object and image distances. For a converging (convex) lens, parallel rays are brought to a real <strong>focal point</strong> F on the far side. The focal length f is positive. Using the <strong>thin lens formula</strong> and drawing three principal rays, we can locate and characterise any image for any object position.
      </p>
      <DiagramConvergingLens/>
      <DiagramLensImages/>
      <Table2 rows={[
        ["Thin lens formula","1/f = 1/v − 1/u  (Cartesian sign convention)\nor  1/v + 1/|u| = 1/f  (real-is-positive)\nf > 0 converging; f < 0 diverging"],
        ["Sign convention (Cartesian)","Distances measured from optical centre\nReal object: u negative; real image: v positive\nf positive for converging, negative for diverging"],
        ["Linear magnification","m = v/u  (Cartesian) or  m = −v/u  (real-is-positive)\n|m| > 1 magnified; |m| < 1 diminished; m < 0 inverted"],
        ["Power of a lens","P = 1/f  (unit: dioptre, D = m⁻¹)\nConverging: P > 0; diverging: P < 0\nCombined lenses in contact: P_total = P₁ + P₂"],
        ["Lensmaker's equation","1/f = (n−1)[1/R₁ − 1/R₂]\nn = refractive index, R₁, R₂ = radii of curvature (signed)\nLinks focal length to the physical shape of the lens"],
        ["Three principal rays","① Parallel to axis → refracts through far focal point F₂\n② Through optical centre → passes undeviated\n③ Through near focal point F₁ → emerges parallel to axis"],
        ["Real image","Formed by actual convergence of rays; can be projected onto screen\nAlways inverted for converging lens with object beyond F"],
        ["Virtual image","Rays diverge; image formed by back-extrapolation (dashed lines)\nAlways upright; cannot be projected onto screen"],
      ]}/>

      <h2 style={S.h2}>Thin Lenses — Diverging</h2>
      <DiagramDivergingLens/>
      <Table2 rows={[
        ["Diverging lens","Thinner at centre than edges; f negative; P negative\nAlways produces virtual, upright, diminished image regardless of object position"],
        ["Image properties","Virtual (same side as object), upright, |m| < 1 (diminished)\nImage between F and lens for any real object"],
        ["Application — myopia","Concave lens placed in front of eye diverges rays before they enter\nEquivalent to reducing converging power of eye's lens system\nPower of corrective lens ≈ −1/far-point distance"],
        ["Combination of lenses","Lenses separated by distance d: 1/f = 1/f₁ + 1/f₂ − d/(f₁f₂)\nIn contact (d→0): 1/f = 1/f₁ + 1/f₂ → P = P₁ + P₂"],
        ["Newton's lens equation","x₁x₂ = f²  (x₁, x₂ = distances from focal points to object/image)\nAlternative form; useful when distances from F are known"],
      ]}/>

      <h2 style={S.h2}>Curved Mirrors</h2>
      <p style={S.p}>
        Spherical mirrors — both concave (converging) and convex (diverging) — obey the same mirror formula as the thin lens equation. The centre of curvature C lies at distance R from the mirror, and the focal length f = R/2. Unlike lenses, mirrors work for any wavelength and produce no chromatic aberration, making large concave mirrors the preferred choice for reflecting telescopes.
      </p>
      <DiagramCurvedMirrors/>
      <Table2 rows={[
        ["Mirror formula","1/f = 1/v + 1/u  (using real-is-positive or Cartesian)\nf = R/2  (R = radius of curvature)"],
        ["Concave mirror — beyond C","Real, inverted, diminished image between F and C\nUsed in: headlights (object at F → parallel beam), dental mirrors, shaving mirrors"],
        ["Concave mirror — between F and C","Real, inverted, magnified image beyond C"],
        ["Concave mirror — at F","Image at infinity (parallel reflected beam) — used in searchlights"],
        ["Concave mirror — inside F","Virtual, upright, magnified image behind mirror — shaving/makeup mirror"],
        ["Convex mirror","Always virtual, upright, diminished — image behind mirror\nUsed: car rear-view mirrors, shop security mirrors, road junctions\nAdvantage: wide field of view"],
        ["Paraxial approximation","Mirror and lens formulas hold exactly only for rays close to the axis\nFor wider beams: spherical aberration occurs"],
        ["Parabolic mirror","Eliminates spherical aberration for on-axis parallel rays\nUsed in reflecting telescopes, satellite dishes, car headlights, solar concentrators"],
        ["Magnification (mirror)","m = −v/u  (Cartesian)\nm > 0: upright; m < 0: inverted; |m| > 1: magnified"],
      ]}/>

      <h2 style={S.h2}>Dispersion, Prisms and Colour</h2>
      <DiagramPrism/>
      <Table2 rows={[
        ["Dispersion","Variation of refractive index with wavelength: n = n(λ)\nNormal dispersion: n decreases as λ increases (most glass in visible range)"],
        ["Cauchy equation","n(λ) ≈ A + B/λ² + C/λ⁴\nA, B, C are material-specific constants; B/λ² term usually dominant"],
        ["Abbe number (V-number)","V = (n_D − 1) / (n_F − n_C)\nMeasures dispersion relative to refraction; high V = low dispersion (crown glass V~64)"],
        ["Prism deviation","Angle of deviation δ = (n−1)A  for small-angle prism (A = apex angle)\nGeneral: δ = (i₁+i₂) − A  (i₁, i₂ = entry/exit angles)"],
        ["Minimum deviation","δ_min when ray passes symmetrically through prism\nn = sin[(A+δ_min)/2] / sin(A/2)  — standard method for measuring n"],
        ["Rainbow","Primary bow: TIR inside raindrop at 42° (red) to 40° (violet)\nSecondary bow: two internal reflections, colours reversed, at ~51°\nAlexander's dark band between primary and secondary bows"],
        ["Chromatic aberration","Lens has different focal lengths for different colours: f ∝ 1/(n−1)\nLongitudinal CA: focal lengths differ along axis\nTransverse CA: different magnifications for different colours at one image plane"],
        ["Achromatic doublet","Two lenses of different glass types cemented together\nChoose glasses so chromatic aberration cancels: P₁V₁ + P₂V₂ = 0\nUsed in all quality camera lenses, microscope objectives, eyepieces"],
        ["Apochromat","Corrected at three wavelengths (and also for spherical aberration)\nUsed in high-quality microscope objectives and fluorescence imaging"],
      ]}/>

      <h2 style={S.h2}>The Human Eye</h2>
      <DiagramEye/>
      <Table2 rows={[
        ["Optical structure","Cornea (fixed power ≈ +43D) + crystalline lens (variable +15 to +25D)\nTotal power ≈ +60D; image formed on retina (inverted)"],
        ["Accommodation","Ciliary muscles change lens shape to vary its power\nNear point: ~25 cm (young adult); far point: infinity (normal eye)"],
        ["Myopia (short-sight)","Far point < ∞; eye too long or cornea too curved\nCorrected by diverging lens: P = 1/far_point (in metres), negative value"],
        ["Hyperopia (long-sight)","Near point > 25 cm; eye too short or lens too flat\nCorrected by converging lens to bring near point to 25 cm"],
        ["Astigmatism","Cornea is not spherically symmetric → different focal lengths in different planes\nCorrected by cylindrical or toric lenses"],
        ["Presbyopia","Loss of accommodation with age (lens stiffens); near point recedes\nCorrected with reading glasses (converging); bifocals for near and far"],
        ["Resolving power of eye","Angular resolution ≈ 1 arcminute (~0.3 mm at 25 cm)\nLimited by cone spacing in fovea (~2 μm) and diffraction at pupil (diameter 2–8 mm)"],
        ["Colour vision","Three cone types (S, M, L) peak at ~420, 530, 560 nm\nColour blindness: absence or mutation of one cone type; most common: red-green"],
        ["Pupil","Iris controls pupil diameter: 2 mm (bright) to 8 mm (dark)\n16× change in area → ≈ 12 dB change in admitted light intensity"],
      ]}/>

      <h2 style={S.h2}>Optical Instruments</h2>
      <p style={S.p}>
        Optical instruments extend human vision by forming images with greater magnification, resolution, or at inaccessible wavelengths. All are ultimately combinations of converging and diverging lenses and/or mirrors, governed by the thin lens and mirror formulas. The key figure of merit is usually <strong>angular magnification</strong> — the ratio of the angle subtended by the image to the angle subtended by the unaided object at the near point (25 cm).
      </p>
      <Table2 rows={[
        ["Simple magnifying glass","Single converging lens; object inside F\nAngular magnification M = D/f  (D = 25 cm near point, lens used in relaxed eye)\nM = 1 + D/f  (object at near point of lens)"],
        ["Compound microscope","Objective (short f, ≈ 4–40×) forms real magnified intermediate image\nEyepiece acts as magnifying glass for that image\nTotal M = m_obj × M_eye = (L/f_obj)(D/f_eye)  (L = tube length ~160 mm)"],
        ["Astronomical telescope (refracting)","Objective (long f_obj) collects light; eyepiece (short f_eye) magnifies\nAngular magnification M = −f_obj/f_eye (minus = inverted)\nTube length L = f_obj + f_eye  (normal adjustment, object at ∞)"],
        ["Reflecting telescope (Newtonian)","Parabolic primary mirror replaces objective lens\nNo chromatic aberration; large diameter possible (8–39 m primary mirrors)\nSecondary flat mirror diverts light to side-mounted eyepiece"],
        ["Cassegrain telescope","Convex secondary mirror sends light back through hole in primary\nCompact design; long effective focal length in short tube\nUsed in most large professional telescopes and radio dishes"],
        ["Camera","Converging lens system forms real inverted image on sensor/film\nf-number = f/D (D = aperture diameter)\nExposure time and f-number control depth of field and light collected"],
        ["f-number (aperture)","N = f/D;  Intensity ∝ 1/N²\nHalving N doubles linear diameter → 4× light; f/1.4 admits 2× light of f/2"],
        ["Depth of field","Range of object distances giving acceptably sharp image\nSmall aperture (high N): large depth of field; large aperture: shallow DOF"],
        ["Projector/slide projector","Object (slide) between F and 2F of converging lens\nProduces real, inverted, magnified image on screen\nSlide inserted upside down so image appears correct way up"],
        ["Endoscope","Coherent fibre bundle carries image; outer fibres illuminate\nGraded-index (GRIN) rod lenses often used for objective\nAllows imaging in inaccessible cavities (medical, industrial)"],
      ]}/>

      <h2 style={S.h2}>Lens and Mirror Aberrations</h2>
      <p style={S.p}>
        Real optical systems deviate from the ideal thin-lens model due to <strong>aberrations</strong> — systematic departures from perfect imaging. There are seven primary (Seidel) aberrations. Understanding and correcting them is the central challenge of optical engineering.
      </p>
      <Table2 rows={[
        ["Spherical aberration","Rays through outer zones of a spherical lens focus closer than paraxial rays\nResults in blurred image; corrected by aspherical lens surfaces or stopped-down aperture"],
        ["Chromatic aberration (longitudinal)","Different colours (wavelengths) focus at different distances along axis\nCorrected by achromatic doublet: crown glass + flint glass (opposite dispersion)"],
        ["Chromatic aberration (transverse)","Different colours form images of different sizes at the paraxial focal plane\nCorrected by apochromatic triplets or fluorite elements"],
        ["Coma","Off-axis point sources produce comet-shaped blur\nWorse at large aperture and large field angle; corrected by lens shape"],
        ["Astigmatism (optical)","Off-axis rays in two perpendicular planes focus at different distances\nProduces elongated or cross-shaped blur; corrected by tilted or curved field designs"],
        ["Field curvature (Petzval)","Image surface is curved rather than flat\nFlatField lenses curve elements to match; CCD sensor may be curved to compensate"],
        ["Distortion","Magnification varies across the field: barrel (M decreases) or pincushion (M increases)\nCannot be corrected by aperture; corrected by symmetric lens design or software"],
        ["Diffraction limit","Even perfect optics cannot focus beyond the Rayleigh criterion\nθ_min ≈ 1.22 λ/D — sets fundamental resolution limit; aberrations must stay below this"],
        ["Strehl ratio","Ratio of peak intensity of aberrated PSF to perfect PSF\nStrehl > 0.8 considered diffraction-limited (Maréchal criterion ≈ λ/14 wavefront RMS)"],
      ]}/>

      <h2 style={S.h2}>Magnification — Linear and Angular</h2>
      <Table2 rows={[
        ["Linear (transverse) magnification","m = image height / object height = v/u  (with sign)\nFor lens: m = −v/u (Cartesian); for mirror: m = −v/u"],
        ["Longitudinal magnification","m_long = −m²  (for thin lens)\nAxial distances near the image plane are magnified by m²; important in 3D imaging"],
        ["Angular magnification","M = β/α  (β = angle subtended by image, α = by unaided object at near point D)\nUsed for magnifying glass, eyepiece, telescope, microscope eyepiece"],
        ["Magnifying glass M","M = D/f  (relaxed eye, image at ∞) or  M = 1 + D/f  (near point accommodation)\nD = 25 cm standard near point"],
        ["Telescope M","M = −f_obj / f_eye  (minus = inverted astronomical image)\nUseful magnification limited by diffraction: M_max ≈ D_obj / 0.12 mm"],
        ["Microscope M","M_total = −(L/f_obj) × (D/f_eye)\nL = mechanical tube length (~160 mm); objective labelled with its magnification"],
        ["Empty magnification","Magnifying beyond what resolving power supports just enlarges blur\nNo new detail revealed; maximum useful M ≈ 500–1000 for light microscope"],
      ]}/>

      <h2 style={S.h2}>Fibre Optics and Modern Applications</h2>
      <Table2 rows={[
        ["Step-index multimode fibre","Core ~50–62.5 μm; many modes travel at different angles\nHigh bandwidth over short distances; used in data centres"],
        ["Single-mode fibre","Core ~8–10 μm; only one mode propagates → no modal dispersion\nUsed in long-haul telecom (transatlantic cables); bandwidth >100 Tbps on one fibre"],
        ["Fibre losses","Rayleigh scattering ∝ 1/λ⁴; IR absorption window at 1310 nm and 1550 nm\nMinimum loss ≈ 0.2 dB/km at 1550 nm (silica glass)"],
        ["Wavelength-division multiplexing","Multiple wavelengths (colours) carry independent data channels on one fibre\nDense WDM: >80 channels separated by 0.8 nm; enables Tbps data rates"],
        ["GRIN lens","Graded refractive index rod: rays follow sinusoidal paths\nUsed as collimator or focuser at fibre ends; no curved surfaces needed"],
        ["Gradient-index fibre","Parabolic n profile: outer zones have lower n → all modes travel at same speed\nReduces modal dispersion vs step-index; used in LAN multimode fibres"],
        ["LiDAR","Laser pulses reflected from surfaces; time-of-flight → distance\nd = ct/2; used in autonomous vehicles, topographic mapping, atmospheric sensing"],
        ["Optical coherence tomography","Low-coherence interferometry using near-IR light\nImages biological tissue to ~10 μm resolution; standard in retinal diagnostics"],
      ]}/>

      <InfoBox title="Key Formulae — Geometric Optics" items={[
        "Law of reflection:  θᵢ = θᵣ  (from normal)",
        "Snell's Law:  n₁ sinθ₁ = n₂ sinθ₂",
        "Refractive index:  n = c/v  and  n = λ_vac / λ_medium",
        "Critical angle:  sinθc = n₁/n₂  (light in medium n₂ > n₁ hitting boundary with n₁)",
        "Apparent depth:  d_apparent = d_real / n  (normal incidence)",
        "Thin lens formula:  1/v − 1/u = 1/f  (Cartesian)  or  1/v + 1/u = 1/f  (real-positive)",
        "Mirror formula:  1/v + 1/u = 1/f = 2/R",
        "Linear magnification:  m = v/u  (with sign conventions)",
        "Lens power:  P = 1/f  (dioptres, D = m⁻¹);  combined lenses in contact: P = P₁ + P₂",
        "Lensmaker's equation:  1/f = (n−1)[1/R₁ − 1/R₂]",
        "Angular magnification (glass):  M = D/f  (D = 0.25 m)",
        "Telescope magnification:  M = −f_obj / f_eye",
        "Prism minimum deviation:  n = sin[(A+δ_min)/2] / sin(A/2)",
        "Diffraction limit (Rayleigh):  θ_min = 1.22λ/D",
      ]}/>
    </div>
  );
}